import { render, staticRenderFns } from "./SurfInlineTwoTextStyle2.vue?vue&type=template&id=8149a0e0&scoped=true"
import script from "./SurfInlineTwoTextStyle2.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfInlineTwoTextStyle2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SurfInlineTwoTextStyle2.vue?vue&type=style&index=0&id=8149a0e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8149a0e0",
  null
  
)

export default component.exports